import constants from '@/libs/constant/constants'
import {message, errorHandler, logout, loader, getImageUrl, onError, beforeAvatarUpload} from '@/libs/helper'
import {
    uploadImage,
    updateUserProfile,
    getImageUploadURL,
    bulkUpdate
} from '@/libs/api/api'
export default {
    name: 'ImageUpload',
    props: {
        isEdit: {
            type: Boolean,
            default: ()=> false
        },
        module: {
            type: String,
            default: () => constants.AUTHOR.key
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        claimTo: {
            type: Object,
            default: () => {}
        },
        disabled: {
            type: Boolean,
            default: ()=> false
        },
    },
    watch: {
        claimTo (value) {
            this.imagePreview = value.imagePreview
            this.imageAvatar = value.avatar_image
        }
    },
    data() {
        return {
            uploadImageData: {},
            imageAvatar: this.claimTo.avatar_image || null,
            getImageUrl,
            onError,
            imageName: '',
            imagePreview: this.claimTo && this.claimTo.imagePreview || null,
            beforeAvatarUpload
        }
    },
    methods: {
        getPhotoLabel(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Author Photo'
                case constants.PUBLISHER.key:
                    return 'Publisher Logo'
                case constants.PUBLICATION.key:
                    return 'Publication Logo'
                case 'ADMIN':
                    return 'User Photo'
            }
        },
        getPhotoDescriptionLabel(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Select the photo of the Author (png, jpeg)'
                case constants.PUBLISHER.key:
                    return 'Select the official logo of the Publisher (png, jpeg)'
                case constants.PUBLICATION.key:
                    return 'Select the official logo of the Publication (png, jpeg)'
                case 'ADMIN': 
                    return 'Select the official logo of the User (png, jpeg)'
            }
        },
        handleAvatarSuccess () {
        },
        uploadFile (file) {
            this.imageName = file.file.name
            this.uploadImage(this.module, file)
        },
         /*
        * uploadImage() uploads the image to the s3 server
        * */
       uploadImage: async function(module, file){
        loader(this, true);
        getImageUploadURL({imageName: this.imageName})
            .then((uploadUrls)=>{
                this.uploadImageData = uploadUrls;
                return this.createBlobObject(uploadUrls, file.file)
            }).then((image)=>{
                return uploadImage(image)
            }).then(()=>{
                let body = {
                    avatar_image: this.uploadImageData.fileKey,
                    entity_ids: [this.$route.params.id]
                }
                if(module !== 'ADMIN'){
                    return bulkUpdate(module.toLowerCase(), body)
                } else if(module === 'ADMIN') {
                    delete body.entity_ids
                    body.user_id = this.claimTo._id
                    return updateUserProfile(body)
                }
                return bulkUpdate(module.toLowerCase(), body)
            }).then((response)=>{
                loader(this, false);
                this.imageAvatar = this.uploadImageData.fileKey
                if (module !== 'ADMIN') {
                    this.$emit('updateFormData', this.imageAvatar)
                } else {
                    this.$emit('updateFormData', response)
                }
                message(this, constants.messageType.SUCCESS, 'Updated Successfully');
            }).catch((error)=> {
                loader(this, false);
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            });
    },
    /*
    * createBlobObject() creates and returns the binary image format to upload
    * */
    createBlobObject(uploadUrl, file){
        return new Promise((resolve) => {
                let reader = new FileReader(file)
                reader.addEventListener("loadend",function (data) {
                    return resolve({imageData: data.target.result, uploadUrl })
                });
                reader.readAsArrayBuffer(file);
            })
         },
    },
}